import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/_work/hg-client/hg-client/apps/web/src/app/(navigation)/promo/founding-vendor/FoundingVendorPromoPage.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/_work/hg-client/hg-client/apps/web/src/components/Page.module.css");
